export const CErrorSavingsContext = {
    GET_GOALS: 'GET_GOALS',
    ADD_MONEY_TO_SAVING_GOAL: "ADD_MONEY_TO_SAVING_GOAL"
} as const;